<template>
  <div class="news-detail">
    <div class="news-detail-title">{{data.title}}</div>
    <div class="news-detail-time">{{data.create_time}}</div>
    <div class="news-detail-content" v-html="data.content"></div>
  </div>
</template>
<script>
import { formatCreateTime } from '@/utils/dateFormat'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    getDetail(id) {
      let _this = this;
      this.axios.get(this.$rootUrl + "/unidt/get_article" + "?id=" + id).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          _this.data = formatCreateTime({ ...data })
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },
  }
}
</script>
<style lang="less" scoped>
.news-detail {
  padding: 96px 64px;
  .news-detail-title {
    font-size: 36px;
    color: #08204D;
    line-height: 56px;
    margin-top: 42px;
    text-align: center;
  }
  .news-detail-time{
    font-size: 24px;
    font-weight: 400;
    color: #97A2B5;
    line-height: 36px;
    margin-top: 24px;
    text-align: center;
  }
  .news-detail-content {
    font-size: 24px;
    font-weight: 400;
    color: #08204D;
    line-height: 40px;
    margin-top: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/news/detail.vue